module.exports = __webpack_public_path__ + "img/ro.240de470.jpg";